import axios from 'axios'

// 课程概述
export function getCourseView(params) {
    return axios({
        url: '/course/teachCourseConstruction/visual/getCourseView',
        method: 'get',
        params
    })
}
//课程内容
export function getCourseContent(params) {
    return axios({
        url: '/course/teachCourseConstruction/getCourseContent',
        method: 'get',
        params
    })
}
//课程评价-通过开课id查询我的评价
export function queryOwnComment(params) {
    return axios({
        url: '/course/teachComment/querymyteachComment',
        method: 'get',
        params
    })
}
//课程评价-通过id删除
export function deleteOwnComment(params) {
    return axios({
        url: '/course/teachComment/delete',
        method: 'delete',
        params
    })
}
//课程教学团队
export function getListByCourse(params) {
    return axios({
        url: '/course/teachCourseGroup/getListByCourse',
        method: 'get',
        params
    })
}
//课程统计---作业
export function getHomeworkStatistics(params) {
    return axios({
        url: '/home/getHomeworkStatistics',
        method: 'get',
        params
    })
}

//课程统计---作业/测试
export function getHomeworkTestStatistics(params) {
    return axios({
        url: '/home/getHomeworkTestStatistics',
        method: 'get',
        params
    })
}

//课程统计---统计测验详情
export function getTestStuAveScoreList(params) {
    return axios({
        url: '/home/getTestStuAveScoreList',
        method: 'get',
        params
    })
}
//课程统计---课程基本信息
export function basicInformation(params) {
    return axios({
        url: '/course/statistics/visual/queryBasicInformationById',
        method: 'get',
        params
    })
}
//课程统计---讨论统计
export function queryDiscuss(params) {
    return axios({
        url: '/course/statistics/visual/queryDiscussById',
        method: 'get',
        params
    })
}
//课程统计---开课-资源占比
export function queryResource(params) {
    return axios({
        url: '/course/statistics/visual/queryResourceById',
        method: 'get',
        params
    })
}
//课程统计---统计的考试
export function getExamStuPassRateList(params) {
    return axios({
        url: '/home/getExamStuPassRateList',
        method: 'get',
        params
    })
}